<!-- 企业级-业务领域-仓储业务 -->
<template>
  <div class="mainArea CStorage">
      <!-- 主要头部内容 -->
      <div class="mainHeadContent">
        <!-- 面包屑 -->
        <CBreadCrumb></CBreadCrumb>
      </div>
      <!--主内容区-->
      <div class="mainBodyContent">
        <div class="List">
          <div class="item">
            <div class="img"><img src="" alt=""></div>
            <div class="name">仓库管理</div>
            <div class="detail" @click="toStoDetail('CWarehouseManage','仓库管理')">详情</div>
          </div>
          <div class="item">
            <div class="img"><img src="" alt=""></div>
            <div class="name">产品管理</div>
            <div class="detail" @click="toStoDetail('CProductManage','产品管理')">详情</div>
          </div>
          <div class="item">
            <div class="img"><img src="" alt=""></div>
            <div class="name">初始化管理</div>
            <div class="detail" @click="toStoDetail('CInitManage','初始化管理')">详情</div>
          </div>
          <div class="item">
            <div class="img"><img src="" alt=""></div>
            <div class="name">产品授权</div>
            <div class="detail" @click="toStoDetail('CProductAuth','产品授权')">详情</div>
          </div>
          <!-- <div class="item">
            <div class="img"><img src="" alt=""></div>
            <div class="name">预约管理</div>
            <div class="detail" @click="toStoDetail('CBookManage','预约管理')">详情</div>
          </div> -->
          <div class="item">
            <div class="img"><img src="" alt=""></div>
            <div class="name">出入库管理</div>
            <div class="detail" @click="toStoDetail('COutInWareManage','出入库管理')">详情</div>
          </div>
          <!-- <div class="item">
            <div class="img"><img src="" alt=""></div>
            <div class="name">库存记录</div>
            <div class="detail" @click="toStoDetail('CInventoryRecord','库存管理')">详情</div>
          </div>
          <div class="item">
            <div class="img"><img src="" alt=""></div>
            <div class="name">盘点记录</div>
            <div class="detail" @click="toStoDetail('CStoreRecord','盘点记录')">详情</div>
          </div>
          <div class="item">
            <div class="img"><img src="" alt=""></div>
            <div class="name">复核管理</div>
            <div class="detail" @click="toStoDetail('CReview','复核管理')">详情</div>
          </div> -->
        </div>
      </div>
      
  </div>
</template>

<script>
  import CBreadCrumb from "../Layout/CBreadCrumb.vue"
  import { showToast,updataBreadCrumb } from "../../../../static/js/utility/utility.js"

  export default {
    name: 'CStorage',
    components: {
      CBreadCrumb,
    },
    data() {
      return {
        
      };
    },
    mounted(){

    },
    created: async function () {
      
    },
    methods: {
      //跳转到业务页面
      toStoDetail(url,name){
        var navBarActive = [{function_tab: url, function_name: name}]
        // 更新面包屑内容
        updataBreadCrumb(3, navBarActive)
        this.$router.push({
          path:'/' + url
        })
      },
      
    },
    watch: {
      
    }
  }
</script>

<style lang="scss">
.CStorage{
  .List{
    display: flex;
    flex-wrap: wrap;
    .item{
      margin: 0 10px 20px;
      text-align: center;
      width: 160px;
      height: 200px;
      box-sizing: border-box;
      position: relative;
      box-shadow: 0 2px 3px 0 rgba(0, 0, 0, .26);
      border-radius: 4px;
      overflow: hidden;
      .img{
        padding: 10px;
        height: 140px;
        background: #ccc;
        overflow: hidden;
        img{width: 100%;}
      }
      .name{
        height: 60px;
        line-height: 60px;
      }
      .detail{
        // display: none;
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 60px;
        line-height: 60px;
        background: #fff;
        transition: all .3s;
        opacity: 0;
        z-index: -1;
      }
      &:hover .detail{
        opacity: 1;
        z-index: 1;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/CStorage/CStorage.vue